module.exports = __webpack_public_path__ + "fonts/Lato-Italic.4ffc48d0.ttf";